import React, { ReactElement } from "react";
import OfficeCubicleQuotesWrapper from "@components/layouts/officecubiclequotesWrapper";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import MainBanner from "@components/officecubiclequotes/mainBanner";
import { useDomainContext } from "@hooks/useDomainContext";
const Benefits = dynamic(
    () => import("@components/officecubiclequotes/benefits"),
);
const OffersList = dynamic(() => import("@components/shared/offersList"));
export default function OfficeCubicleQuotesHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <OfficeCubicleQuotesWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <Benefits />
        </OfficeCubicleQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
